import React from 'react';
import { Column } from '../../hooks/useTablePages';
import { TesterVendor } from './types';
import StatusDot, { StatusStyle } from '../Status/StatusDot';

const columns: Column[] = [
  {
    header: 'Approval',
    id: 'approval',
    accessor: (row: TesterVendor) => {
      let approvalStatus: StatusStyle = 'default';
      switch (row.profile.approval) {
        case 'PENDING':
          approvalStatus = 'default';
          break;
        case 'APPROVED':
          approvalStatus = 'success';
          break;
        case 'REJECTED':
        case 'SUSPENDED':
          approvalStatus = 'error';
          break;
      }
      return <StatusDot status={approvalStatus} />;
    },
    stringAccessor: (row: TesterVendor) => row.profile.approval,
    width: 95,
  },
  {
    header: 'First Name',
    accessor: 'profile.firstName',
    width: 100,
  },
  {
    header: 'Last Name',
    accessor: 'profile.lastName',
    width: 130,
  },
];

export default columns;
